module.exports = __webpack_public_path__ + "img/avatar.c81d859e.svg";